import { Box, Stack, Typography } from '@mui/material'
import BlueLogo from 'shared/components/BlueLogo'
import { getPxAsRem } from 'shared/utils'

export interface SignUpSignInProps extends React.PropsWithChildren {
    title: string
}

const SignUpSignIn: React.FC<SignUpSignInProps> = ({ title, children }) => {
    return (
        <Box
            sx={{
                display: 'grid',
                height: '100vh',
                placeItems: 'center',
                padding: getPxAsRem(24),
            }}
        >
            <Stack maxWidth={getPxAsRem(440)} spacing={2}>
                <Stack direction={'column'} spacing={0.05}>
                    <BlueLogo heightOverride={getPxAsRem(60)} />
                    <Typography
                        variant="h3"
                        margin={getPxAsRem(24, 0, 48)}
                        alignContent={'center'}
                    >
                        {title}
                    </Typography>
                </Stack>

                {children}
            </Stack>
        </Box>
    )
}

export default SignUpSignIn
